var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"row"},[_c('div',{staticClass:"col-12",class:{ 'row items-center justify-center': _vm.centered, 'layout-padding': _vm.padding },on:{"click":_vm.yourClickHandler}},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056d4597","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Page.vue
// module id = p2/C
// module chunks = 46